import { useMutation } from "@apollo/client/react";
import { CREATE_COMMENT } from "../mutations/createComment";
import GET_ALL_UPLOAD_UNITS from "../queries/documentHandler/getAllUploadUnits";

export const useCreateComment = ({
  onCompleted,
  onError,
  noRefetch = false,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
  noRefetch?: boolean;
}) => {
  const [createComment, { data, loading, error }] = useMutation(
    CREATE_COMMENT,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: noRefetch ? [] : [GET_ALL_UPLOAD_UNITS],
      awaitRefetchQueries: true,
    }
  );

  return { createComment, data, loading, error };
};
